module.exports = __webpack_public_path__ + "static/media/3. Hurray, you made it.716b2686.svg";